import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { BADGE_COLORS } from '../../../../../../shared/components/Tag';
import { formatTime } from '../../../../utils';

const Appointment = ({ color, onClick, startAt, title }) => {
  const containerStyles = cn(
    'flex items-center gap-1.5 rounded border px-1.5 py-0.5 truncate',
    BADGE_COLORS[color]
  );

  return (
    <div className={containerStyles} onClick={onClick} title={title}>
      <span className="text-[10px] font-semibold tabular-nums shrink-0">
        {formatTime(new Date(startAt))}
      </span>

      <span className="text-[11px] font-medium truncate">{title}</span>
    </div>
  );
};

Appointment.propTypes = {
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  startAt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Appointment;
